import React from 'react';

const lazyImport = (importStmt) => {
    return React.lazy(importStmt);
}

export default lazyImport;